import axios from "axios";

const DEFAULT_PROMO_ERROR = 'There was an error applying your discount code, please try again later';


export const sendPromoValidationRequest = async (promoCode, apiUrl, apiAccessToken) => {
    try {
      return await axios.get(`${apiUrl}/jp/promotional-discounts?channel=web&promoCode=${promoCode}`, {
          headers: {
            'X-Access-Token': apiAccessToken
          }
        });
    } catch (e) {
        return {
            data: {
                errors: [
                    new Error(DEFAULT_PROMO_ERROR)
                ]
            }
        }

    }
}
